<template>
  <transition appear name="modal" :duration="300">
    <UIDialogRoot
      modal
      dismissible
      class="product-trial-dialog"
      style="--bs-modal-width: 550px"
      :visible="visible"
      @dismiss="hide()"
    >
      <UIDialog>
        <UIDialogContent>
          <!-- <UIDialogHeader title="Start my trial" /> -->

          <UIDialogBody>
            <iframe
              v-if="iframeUrl?.length"
              class="product-trial-dialog__iframe"
              :src="iframeUrl"
            ></iframe>

            <slot v-else></slot>
          </UIDialogBody>
        </UIDialogContent>
      </UIDialog>
    </UIDialogRoot>
  </transition>
</template>

<script lang="ts">
type ProductTrialDialogProps = {
  /** Display form in iframe instead. */
  iframeUrl?: string;
};

export const ProductTrialDialogId = "product-trial-dialog";
</script>

<script lang="ts" setup>
import { latestAction } from "@/app/App";
import {
  UIDialog,
  UIDialogBody,
  UIDialogContent,
  UIDialogRoot,
} from "@/components/UI/dialog";
import { useDialog } from "@/components/UI/dialog/useDialog";
import { watch } from "vue";

defineProps<ProductTrialDialogProps>();
const { visible, hide, show } = useDialog(ProductTrialDialogId);

watch(latestAction, (value) => {
  if (value === ProductTrialDialogId) {
    show();
  }
});
watch(visible, (value) => {
  if (!value && latestAction.value === ProductTrialDialogId) {
    latestAction.value = null;
  }
});
</script>

<style lang="scss" scoped>
.product-trial-dialog {
  &__iframe {
    width: 100%;
    border: none;
    height: 600px;
  }
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 300ms ease-out;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
</style>
